<template>
  <v-container class='price-container pa-0'>
    <v-layout row wrap class='price'>
      <v-flex v-if='$i18n.locale() === "th"'>
        <span class='sale-price'>{{ formatPrice(getProductDetail.product.normal_price, getProductDetail.product.special_price, getProductDetail.product.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
        <span v-if='getProductDetail.product.special_price || (getProductDetail.product.member_price && getParams.member === 1)' class='original-price'>{{ formatPrice(getProductDetail.product.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
      </v-flex>
      <v-flex v-else>
        <span class='sale-price'>{{ formatPrice(getProductDetail.product.normal_price, getProductDetail.product.special_price, getProductDetail.product.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
        <span v-if='getProductDetail.product.special_price || (getProductDetail.product.member_price && getParams.member === 1)' class='original-price'>{{ formatPrice(getProductDetail.product.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
      </v-flex>
      <v-flex v-if='parseInt(getProductDetail.product.use_stock) === 1 && getProductDetail.product.sum_stock <= 0' class='text-xs-right'>
        <v-chip color='orange' text-color='white'>
        {{ $t('Out_of_stock') }}
        </v-chip>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="(getProductDetail.product.use_stock === '1' && getProductDetail.product.sum_stock > 0) || getProductDetail.product.use_stock === '0'">
      <div v-if='getProductDetail.product_attribute === null || parseInt(getProductDetail.product_attribute.length) === 0' class='quantity application application--example theme--light grey lighten-3'>
        <v-flex xs4>
          <v-subheader>{{ $t('Quantity') }}</v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-btn class="ma-0" icon v-on:click="decreaseQty()">
            <v-icon color="primary">remove_circle</v-icon>
          </v-btn>
          <div class='qty'>
            <v-select
            v-bind:items='inputQty'
            v-model='currentQty'
            single-line
            ></v-select>
          </div>
          <v-btn class="ma-0" icon v-on:click="increaseQty()">
            <v-icon color="primary">add_circle</v-icon>
          </v-btn>
        </v-flex>
      </div>
      <div v-else class='quantity ma-0'>
        <variant-button></variant-button>
      </div>
    </v-layout>
  </v-container>
</template>
<script>

import getSymbolFromCurrency from 'currency-symbol-map'
import { mapGetters, mapActions } from 'vuex'

import VariantButton from './productVariantButton'

export default {
  name: 'ProductPrice',
  components: {
    VariantButton
  },
  data: () => {
    return {
      qty: 1,
      inputQty: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
    }
  },
  computed: {
    ...mapGetters([
      'getCurrency',
      'getProductDetail',
      'getParams'
    ]),
    currentQty: {
      get: function () {
        return this.qty
      },
      set: function (value) {
        this.setSelectedQuantity(value)
        this.qty = value
        return value
      }
    }
  },
  methods: {
    ...mapActions({
      setSelectedQuantity: 'setSelectedQuantity'
    }),
    decreaseQty () {
      if (this.qty > 1) {
        this.qty -= 1
        this.setSelectedQuantity(this.qty)
      }
    },
    increaseQty () {
      if (this.qty < 20) {
        this.qty += 1
        this.setSelectedQuantity(this.qty)
      }
    },
    formatPrice (normalPrice, specialPrice, memberPrice) {
      var value = ''
      if (memberPrice && this.getParams.member === 1) {
        value = memberPrice
      } else if (specialPrice) {
        value = specialPrice
      } else {
        value = normalPrice
      }

      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  filters: {
    currency (value, code, display, position, name) {
      var text = ''
      if (display === 'iso') {
        text = code
      } else if (display === 'symbol') {
        text = getSymbolFromCurrency(code)
      } else {
        text = name
      }
      if (position === 'prefix') {
        return text + ' ' + value
      } else {
        return value + ' ' + text
      }
    }
  }
}
</script>

<style type='text/css' lang='scss'>
.price-container {
  .price {
    line-height: 40px;
    .sale-price {
      font-size: 16px;
      color: green;
      font-weight: bold;
      line-height: inherit !important;
      margin-right: 10px;
    }
    .original-price {
      font-size: 12px;
      color: gray;
      text-decoration: line-through;
    }
    .has-text-right {
      float: right;
    }
  }
  .quantity {
    border: 1px;
    border-style: solid;
    border-color: #e1e1e1 !important;
    border-radius: 4px;
    width: 100%;
    .subheader {
      font-size: 16px;
    }
    .sub-color {
      color: blue;
    }
    .xs8 {
      display: flex;
      height: 55px;
      align-items: center;
      .qty {
        display: inline-block;
        font-size: 20px;
        margin: 0 10px;
        width: 50%;
        .input-group {
          padding: 0;
          .input-group__input {
            text-align: center;
            min-height: initial;
            border: #ccc solid 1px;
            background: #fff;
            padding-left: 5px;
            input {
              text-align: center;
            }
            .menu {
              .menu__content {
                top: 0 !important;
                left: inherit !important;
                right: 0;
              }
            }
          }
          .input-group__details {
            display: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productDetail/productPrice/index.vue